<template>
  <div class="blue-background">
    <div>
      <div class="container">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
@import "./../../variables.scss";

.blue-background {
  background-image: url("./../../assets/images/background.png");
  background-attachment: fixed;
  > div {
    background-color: $primary;
    opacity: 0.6;
    height: 100%;
  }
  > div > div {
  }
  p,
  h1,
  h2,
  a {
    color: $third;
    text-align: center;
  }
}
</style>
